import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/HomePage'
import BrandList from './views/home/BrandList'
import BannerList from './views/home/BannerList'
import CategoryBrandList from './views/home/CategoryBrandList'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/ticket/ad/',
  routes: [
    {
      path: '/index',
      name: 'homepage',
      component: Home,
      meta: {
        activedIndex: 0,
      },
    },
    {
      path: '/brandList',
      name: 'brandList',
      component: BrandList,
      meta: {
        title: '品牌列表',
        activedIndex: 0,
      },
    },
    {
      path: '/BannerList',
      name: 'bannerList',
      component: BannerList,
      meta: {
        title: 'Banner列表',
        activedIndex: 0,
      },
    },
    {
      path: '/CategoryBrandList',
      name: 'categoryBrandList',
      component: CategoryBrandList,
      meta: {
        title: '分類品牌列表',
        activedIndex: 0,
      },
    },
  ],
})
